import { Component, Input, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { XpressCenterService } from 'app/services';
import { WeekDay } from '@angular/common';
import { Utils } from 'app/utils';
import moment from 'moment';
import { cl } from '@fullcalendar/core/internal-common';

enum CenterDetailsTab {
  Profile = 1,
  Employees = 2,
  Expenses = 3,
  WorkingHours = 4,
  Training = 5,
  Inventory = 6
}

enum TrainingDetailsTab {
  Classroom = 1,
  Driving = 2
}

enum RepeatType {
  OneTime = 0,
  Weekly = 1,
  Monthly = 2
}

@Component({
  selector: 'driver-center-info',
  templateUrl: './driver-center-info.component.html',
  styleUrls: ['./driver-center-info.component.scss'],
  providers: [MessageService]
})
export class DriverCenterInfoComponent implements OnInit {
  public xpressCenter: any;
  @Input()
  set _xpressCenter(value: any) {
    this.xpressCenter = value;
  }

  @Input()
  public showPopup: boolean = false;

  @Input()
  public onHide: () => void = () => { };

  @Input()
  public showEditFields: boolean = false;

  public editableXpressCenter: any;

  public centerDetailsTab = CenterDetailsTab;
  public activeTab: CenterDetailsTab = CenterDetailsTab.Profile;

  public trainingDetailsTab = TrainingDetailsTab;
  public activeTrainingTab: TrainingDetailsTab = TrainingDetailsTab.Classroom;

  public userCols: any[] = [
    { field: 'UserName', header: '', width: '300px', isUserName: true },
    { field: 'Role', header: 'Role', width: '200px' },
    { field: 'LastActive', header: 'Last Active', width: '200px' }
  ];
  public centerUsers: any;
  public selectedUser: any;
  public freeUsers: any;
  public selectedUserToAdd: any;
  public selectedUserRole: any;
  public selectedHoliday: any;
  public addedHolidays: any[] = [];

  public changedOperationHours: any = [];
  public addedOperationDays: any = [];
  public removedOperaionDays: any = [];

  public xpressCenterTrainingSchedule: any = [];
  public selectedTraining: any;
  public showAddTrainingPopup: boolean = false;
  public addedTraining: any = {};

  public xpressCenterRoles = [
    {
      id: 1,
      name: 'Admin'
    },
    {
      id: 2,
      name: 'OnBoarding'
    }
  ];

  public menuItems: MenuItem[] = [
    {
      label: 'Center Profile',
      id: `${CenterDetailsTab.Profile}`,
      command: (e: any) => this.handleTabChange(+e.item.id)
    },
    {
      label: 'Employees',
      id: `${CenterDetailsTab.Employees}`,
      command: (e: any) => this.handleTabChange(+e.item.id)
    },
    {
      label: 'Expenses',
      id: `${CenterDetailsTab.Expenses}`,
      command: (e: any) => this.handleTabChange(+e.item.id)
    },
    {
      label: 'Center Hours',
      id: `${CenterDetailsTab.WorkingHours}`,
      command: (e: any) => this.handleTabChange(+e.item.id)
    },
    {
      label: 'Training',
      id: `${CenterDetailsTab.Training}`,
      command: (e: any) => this.handleTabChange(+e.item.id)
    },
    {
      label: 'Inventory',
      id: `${CenterDetailsTab.Inventory}`,
      command: (e: any) => this.handleTabChange(+e.item.id)
    }
  ];

  public trainingMenuItems: MenuItem[] = [
    {
      label: 'Classroom Training',
      id: `${TrainingDetailsTab.Classroom}`,
      command: (e: any) => this.handleTrainingTabChange(+e.item.id)
    },
    {
      label: 'Defensive Driving',
      id: `${TrainingDetailsTab.Driving}`,
      command: (e: any) => this.handleTrainingTabChange(+e.item.id)
    }
  ];

  public actionsItems: MenuItem[] = [
    {
      label: 'Remove Employee',
      command: () => {
        this.showDialogRemoveUser = true;
      }
    },
    {
      label: 'Suspend Employee',
      command: () => {
        this.showDialogSuspendUser = true;
      }
    },
  ];

  public actionsItemsHolidayHours: MenuItem[] = [
    {
      label: 'Remove Holiday',
      command: () => {
        this.showDialogRemoveHolidayDay = true;
      }
    }
  ];

  public actionsItemsTraining: MenuItem[] = [
    {
      label: 'Remove',
      command: () => {
        this.showDialogRemoveTraining = true;
      }
    }
  ];

  public showDialogRemoveUser: boolean = false;
  public showDialogSuspendUser: boolean = false;
  public showDialogAddUser: boolean = false;
  public showDialogRemoveHolidayDay: boolean = false;
  public showSaveHoliday: boolean = false;
  public showSaveOperationDays: boolean = false;
  public showDialogRemoveTraining: boolean = false;
  public showSaveTraining: boolean = false;

  public loading: boolean = false;
  public viewDiscpilinaryInfo: boolean = true;

  public dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  public repeatType = ['One Time', 'Weekly', 'Monthly'];

  public daysOfWeek = [
    {
      id: WeekDay.Monday,
      label: this.dayNames[1]
    },
    {
      id: WeekDay.Tuesday,
      label: this.dayNames[2]
    },
    {
      id: WeekDay.Wednesday,
      label: this.dayNames[3]
    },
    {
      id: WeekDay.Thursday,
      label: this.dayNames[4]
    },
    {
      id: WeekDay.Friday,
      label: this.dayNames[5]
    },
    {
      id: WeekDay.Saturday,
      label: this.dayNames[6]
    },
    {
      id: WeekDay.Sunday,
      label: this.dayNames[0]
    }];

  public repeatTypes = [
    {
      id: RepeatType.OneTime,
      label: this.repeatType[0]
    },
    {
      id: RepeatType.Weekly,
      label: this.repeatType[1]
    },
    {
      id: RepeatType.Monthly,
      label: this.repeatType[2]
    }];

  public operationHours: any;
  public holidayHours: any;

  constructor(
    private messageService: MessageService,
    private xpressCenterService: XpressCenterService
  ) { }

  ngOnInit(): void {
  }

  public removeUserFromCenter() {
    const dto = {
      Id: this.selectedUser.Id
    };

    this.xpressCenterService.removeEmployeeFromCenter(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee added successfully' });
        this.showDialogRemoveUser = false;
        this.getXpressCenterUsers();
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public suspendUser() {

  }

  public getXpressCenterUsers() {
    this.loading = true;
    const dto = {
      Id: this.xpressCenter.Id
    };
    this.xpressCenterService.getXpressCenterUsers(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.centerUsers = data.Items;

        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public handleSideBarHide(): void {
    this.onHide();
    this.showDialogRemoveUser = false;
    this.showDialogSuspendUser = false;
    this.activeTab = CenterDetailsTab.Profile;
    this.centerUsers = null;
    this.selectedUser = null;
    this.selectedUserRole = null;
    this.selectedUserToAdd = null;
    this.showEditFields = false;
    this.editableXpressCenter = null;
  }

  public handleTabChange(tab: CenterDetailsTab) {
    this.activeTab = tab;
    this.callMethods();
  }

  public handleTrainingTabChange(tab: TrainingDetailsTab) {
    this.activeTrainingTab = tab;
  }

  public setShowEditFields() {
    this.showEditFields = true;
  }

  public setSelectedUser(user: any) {
    this.selectedUser = user;
  }

  public getXpressCenterFreeUsers() {
    this.xpressCenterService.getXpressCenterFreeUsers(null, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.freeUsers = data.Items;

        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public addEmployeeToCenter(user: any) {
    this.loading = true;
    const dto = {
      XpressCenterUserId: user.Id,
      CenterId: this.xpressCenter.Id,
      XpressCenterUserRole: this.selectedUserRole.id
    };

    this.xpressCenterService.addEmployeeToCenter(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee added successfully' });
        this.showDialogAddUser = false;
        this.selectedUserToAdd = undefined;
        this.selectedUserRole = undefined;
        this.getXpressCenterUsers();
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }
  public callMethods() {
    if (this.activeTab === CenterDetailsTab.Employees) {
      this.getXpressCenterUsers();
    }
    if (this.activeTab === CenterDetailsTab.WorkingHours) {
      this.getWorkingHours();
      this.getHolidayHours();
    }
    if (this.activeTab === CenterDetailsTab.Training) {
      this.getTrainingClassroomSchedule();
    }
  }

  public showPopupAddEmployee() {
    this.showDialogAddUser = true;
    this.getXpressCenterFreeUsers();
  }

  public getWorkingHours() {
    const dto = {
      Id: this.xpressCenter.Id
    };

    this.xpressCenterService.getCenterOperationHours(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.operationHours = data.Items.map((x: any) => {
          x.CloseAt = Utils.utcToLocalDate(x.CloseAt);
          x.OpenAt = Utils.utcToLocalDate(x.OpenAt);
          x.DayOfWeek = Utils.toLocalDayOfWeek(x.DayOfWeek, x.OpenAt );
          return x;
        });

        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public getHolidayHours() {
    const dto = {
      Id: this.xpressCenter.Id
    };

    this.xpressCenterService.getCenterHolidayHours(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.holidayHours = data.Items.map((x: any) => {
          x.CloseAt = Utils.utcToLocaleTimeString(x.CloseAt);
          x.OpenAt = Utils.utcToLocaleTimeString(x.OpenAt);
          x.DateStr = Utils.utcToLocaleDateString(x.Date);
          x.DayOfWeek = this.dayNames[Utils.utcToLocalDate(x.Date)?.getDay() ?? 0];
          return x;
        });

        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public isClosed(dayOfWeek: number) {
    let count = 0;
    for (const day of this.operationHours) {
      if (day.DayOfWeek === dayOfWeek) {
        count++;
      }
    }
    for (const day of this.addedOperationDays) {
      if (day.DayOfWeek === dayOfWeek) {
        count++;
      }
    }

    return count === 0;
  }

  public addOperationHours(dayOfWeek: number) {
    this.addedOperationDays.push({
      Id: 0,
      XpressCenterId: this.xpressCenter.Id,
      DayOfWeek: dayOfWeek,
    });
    if (!this.showSaveOperationDays) {
      this.showSaveOperationDays = true;
    }
  }

  public removeHoliday() {
    const dto = {
      Id: this.selectedHoliday.Id
    };

    this.xpressCenterService.removeHolidayFromCenter(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Holiday has been deleted' });
        this.loading = false;
        this.showDialogRemoveHolidayDay = false;
        this.getHolidayHours();
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public saveHolidayHours() {
    const dto = {
      Items: this.addedHolidays,
      TimeZoneOffSet: Utils.getTimezoneOffset()
    };
    let fieldsAreFilled: boolean = true;
    let datesIsCorrect: boolean = true;
    dto.Items.forEach((item: any) => {
      if (!item.OpenAt || !item.CloseAt) {
        fieldsAreFilled = false;
      }
      if (item.OpenAt > item.CloseAt) {
        datesIsCorrect = false;
      }
      item.OpenAt = moment(item.OpenAt).format('YYYY-MM-DDTHH:mm:ss');
      item.CloseAt = moment(item.CloseAt).format('YYYY-MM-DDTHH:mm:ss');
    });

    if (!fieldsAreFilled) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Not all fields are filled' });
      return;
    }
    if (!datesIsCorrect) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Opening time cannot be greater than closing time' });
      return;
    }
    this.xpressCenterService.addHolidayHoursToCenter(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Holiday has been added' });
        this.loading = false;
        this.getHolidayHours();
        this.showSaveHoliday = false;
        this.addedHolidays = [];
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public addHolidayHours() {
    this.addedHolidays.push({
      XpressCenterId: this.xpressCenter.Id,
      OpenAt: new Date(),
      CloseAt: new Date(),
      Date: new Date()
    });
    if (!this.showSaveHoliday) {
      this.showSaveHoliday = true;
    }
  }

  public removeAddedHoliday(holiday: any) {
    this.addedHolidays.forEach((item: any, index: any) => {
      if (item === holiday) {
        this.addedHolidays.splice(index, 1);
      }
    });
    if (this.addedHolidays.length === 0) {
      this.showSaveHoliday = false;
    }
  }

  public changeOperationHours(operationDay: any) {
    if (operationDay.Id === 0) {
      return;
    }
    this.changedOperationHours.forEach((item: any, index: any) => {
      if (item.Id === operationDay.Id) {
        this.changedOperationHours.splice(index, 1);
      }
    });
    this.changedOperationHours.push(operationDay);
    if (!this.showSaveOperationDays) {
      this.showSaveOperationDays = true;
    }
  }

  public removeOperationDay(day: any) {
    this.removedOperaionDays.push({ Id: day.Id });
    this.operationHours.forEach((item: any, index: any) => {
      if (item === day) {
        this.operationHours.splice(index, 1);
      }
    });
    this.changedOperationHours.forEach((item: any, index: any) => {
      if (item.Id === day.Id) {
        this.changedOperationHours.splice(index, 1);
      }
    });
    if (!this.showSaveOperationDays) {
      this.showSaveOperationDays = true;
    }
  }

  public removeAddedOperationDay(day: any) {
    this.addedOperationDays.forEach((item: any, index: any) => {
      if (item === day) {
        this.addedOperationDays.splice(index, 1);
      }
    });
  }

  public saveOperationHoursChanges() {
    const dto = {
      AddedOperationDays: this.addedOperationDays,
      RemovedOperationDays: this.removedOperaionDays,
      ChangedOperationDays: this.changedOperationHours,
      TimeZoneOffSet: Utils.getTimezoneOffset()
    };
    let fieldsAreFilled: boolean = true;
    let datesIsCorrect: boolean = true;
    dto.AddedOperationDays.forEach((item: any) => {
      if (!item.OpenAt || !item.CloseAt) {
        fieldsAreFilled = false;
      }
      if (item.OpenAt > item.CloseAt) {
        datesIsCorrect = false;
      }
      item.OpenAt = moment(item.OpenAt).format('YYYY-MM-DDTHH:mm:ss');
      item.CloseAt = moment(item.CloseAt).format('YYYY-MM-DDTHH:mm:ss');
    });
    dto.ChangedOperationDays.forEach((item: any) => {
      if (item.OpenAt > item.CloseAt) {
        datesIsCorrect = false;
      }
      item.OpenAt = moment(item.OpenAt).format('YYYY-MM-DDTHH:mm:ss');
      item.CloseAt = moment(item.CloseAt).format('YYYY-MM-DDTHH:mm:ss');
    });
    if (!fieldsAreFilled) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Not all fields are filled' });
      return;
    }
    if (!datesIsCorrect) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Opening time cannot be greater than closing time' });
      return;
    }
    this.xpressCenterService.saveOperationDaysChanges(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Operation Hours has been changed' });
        this.loading = false;
        this.getWorkingHours();
        this.showSaveOperationDays = false;
        this.removedOperaionDays = [];
        this.changedOperationHours = [];
        this.addedOperationDays = [];
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public getTrainingClassroomSchedule() {
    const dto = {
      XpressCenterId: this.xpressCenter.Id,
      ClassroomType: 0
    };

    this.xpressCenterService.getTrainingSchedule(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }
        this.xpressCenterTrainingSchedule = data.Items.map((x: any) => {
          x.DayOfWeek = this.dayNames[Utils.toLocalDayOfWeek(x.DayOfWeek, Utils.utcToLocalDate(x.StartAt))];
            x.Repeat = this.repeatType[x.Repeat];
            x.StartAt = Utils.utcToLocaleTimeString(x.StartAt);
            x.FinishAt = Utils.utcToLocaleTimeString(x.FinishAt);
          return x;
        });

        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public removeTraining() {
    const dto = {
      Id: this.selectedTraining.Id
    };

    this.xpressCenterService.removeTraining(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }
        this.selectedTraining = null;
        this.showDialogRemoveTraining = false;
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Training hours has been removed' });
        this.getTrainingClassroomSchedule();
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

    public addTraining(trainingType: any) {
        console.log(moment(this.addedTraining.StartAt).format('YYYY-MM-DDTHH:mm:ss'),);
    const dto = {
      Id: 0,
      XpressCenterId: this.xpressCenter.Id,
      StartAt: moment(this.addedTraining.StartAt).format('YYYY-MM-DDTHH:mm:ss'),
      FinishAt: moment(this.addedTraining.FinishAt).format('YYYY-MM-DDTHH:mm:ss'),
      DayOfWeek: this.addedTraining.DayOfWeek.id,
      Repeat: this.addedTraining.Repeat.id,
      TrainingType: trainingType,
      TimeZoneOffSet: Utils.getTimezoneOffset()
    };

    if (dto.StartAt > dto.FinishAt) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Start time cannot be greater than Finish time' });
      return;
    }

    this.loading = true;

    this.xpressCenterService.addTraining(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Training has been added' });
        this.getTrainingClassroomSchedule();
        this.showAddTrainingPopup = false;
        this.addedTraining = {};
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public setClassroomFacilityFalse() {
    if (!this.xpressCenter.ClassroomFacility) {
      this.xpressCenter.TrainingCapacityClassroom = 0;
    }
    if (!this.showSaveTraining) {
      this.showSaveTraining = true;
    }
  }

  public saveCapacityClassroomInfo() {
    const dto = {
      XpressCenterId: this.xpressCenter.Id,
      TrainingCapacityClassroom: this.xpressCenter.TrainingCapacityClassroom
    };

    this.xpressCenterService.saveTrainingClassroomInfo(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Capacity has been changed' });

        if (dto.TrainingCapacityClassroom === 0) {
          this.xpressCenter.ClassroomFacility = false;
        }

        this.showSaveTraining = false;
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }

  public saveChanges() {
    const dto = {
      Id: this.xpressCenter.Id,
      Address: this.xpressCenter.Address,
      Name: this.xpressCenter.Name,
      CusaFee: this.xpressCenter.CusaFee,
      City: this.xpressCenter.City,
      MonthlyRent: this.xpressCenter.MonthlyRent
    };

    this.xpressCenterService.saveCenterProdileInfo(dto, this.messageService)
      .then(data => {
        if (!data.Success) {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
          return;
        }
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Profile has been changed' });


        this.xpressCenter = this.editableXpressCenter;
        this.xpressCenter.MonthlyRentStr = String.fromCharCode(8369) + this.editableXpressCenter.MonthlyRent;
        this.xpressCenter.ExpensesStr = String.fromCharCode(8369) + this.editableXpressCenter.Expenses;
        this.xpressCenter.CusaFeeStr = String.fromCharCode(8369) + this.editableXpressCenter.CusaFee;
        this.showEditFields = false;
        this.editableXpressCenter = null;
      })
      .catch(err => {
        this.loading = false;
        throw err;
      });
  }
}
